import { useNavigate } from 'react-router-dom';
import { AuthResetPasswordPage } from '@euroasiann/shared/ui';
import { apiFetchUrl } from '../lib/api';
import mapBackground from '../assets/proper_map_bg.png';

export default function ResetPassword() {
  const navigate = useNavigate();

  return (
    <AuthResetPasswordPage
      portalName="Admin Portal"
      backgroundSrc={mapBackground}
      backgroundAlt="Maritime map operations"
      apiFetchUrl={apiFetchUrl}
      onNavigateLogin={() => navigate('/login')}
    />
  );
}
